/* ==========================================================================
   MAIN LIST COLLECTIONS — Standalone JS
   Handles: Infinite scroll / Load more
   ========================================================================== */
(function () {
  'use strict';

  var grid = document.querySelector('[data-product-grid]');
  if (!grid) return;

  var sectionId = grid.dataset.sectionId;

  /* ========================================================================
     INFINITE SCROLL / LOAD MORE
     ======================================================================== */

  var loadMoreContainer = document.querySelector('[data-load-more]');
  var loading = false;

  if (loadMoreContainer) {
    var mode = loadMoreContainer.dataset.mode;
    var btn = loadMoreContainer.querySelector('[data-load-more-btn]');
    var spinner = loadMoreContainer.querySelector('[data-loading]');
    var observer;

    // Auto scroll mode: IntersectionObserver
    if (mode === 'auto' || mode === 'both') {
      observer = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          fetchNextPage();
        }
      }, { rootMargin: '400px' });
      observer.observe(loadMoreContainer);
    }

    // Button click
    if (btn) {
      btn.addEventListener('click', function () {
        fetchNextPage();
      });
    }

    function fetchNextPage() {
      var nextUrl = loadMoreContainer.dataset.nextUrl;
      if (!nextUrl || loading) return;

      loading = true;
      if (btn) btn.disabled = true;
      if (spinner) spinner.hidden = false;

      // Append section_id for Section Rendering API
      var fetchUrl = nextUrl + (nextUrl.indexOf('?') !== -1 ? '&' : '?') + 'section_id=' + sectionId;

      fetch(fetchUrl)
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('[data-product-grid]');

          if (newGrid) {
            var children = Array.from(newGrid.children);
            children.forEach(function (child) {
              grid.appendChild(child);
            });
          }

          // Check for next page
          var newLoadMore = doc.querySelector('[data-load-more]');
          if (newLoadMore && newLoadMore.dataset.nextUrl) {
            loadMoreContainer.dataset.nextUrl = newLoadMore.dataset.nextUrl;
          } else {
            // No more pages
            loadMoreContainer.dataset.nextUrl = '';
            loadMoreContainer.hidden = true;
            if (observer) observer.disconnect();
          }

          loading = false;
          if (btn) btn.disabled = false;
          if (spinner) spinner.hidden = true;
        })
        .catch(function () {
          loading = false;
          if (btn) btn.disabled = false;
          if (spinner) spinner.hidden = true;
        });
    }
  }
})();
